import colors from 'theme/colors'

const Theme = colors.light

const sentimentColors = {
	positive: {
		fg: Theme.colorPositiveFg,
		bg: Theme.colorPositiveBg,
		mg: Theme.colorPositiveMg,
	},
	negative: {
		fg: Theme.colorNegativeFg,
		bg: Theme.colorNegativeBg,
		mg: Theme.colorNegativeMg,
	},
	attentive: {
		fg: Theme.colorAttentiveFg,
		bg: Theme.colorAttentiveBg,
		mg: Theme.colorAttentiveMg,
	},
	important: {
		fg: Theme.colorImportantFg,
		bg: Theme.colorImportantBg,
		mg: Theme.colorImportantMg,
	},
	interactive: {
		fg: Theme.colorInteraction,
		bg: Theme.background,
		fgHover: Theme.colorInteractionHover,
	},
	neutral: {
		fg: Theme.colorNeutralFg,
		bg: Theme.colorNeutralBg,
		mg: Theme.colorNeutralMg,
	},
	// special cases
	labelIco: { fg: Theme.colorLabelIco, bg: Theme.background },
	placeholder: { fg: Theme.colorPlaceholder, bg: Theme.background },
	none: { fg: Theme.colorDark, bg: Theme.background },
	regular: { fg: Theme.colorDark, bg: Theme.background },
	inverted: { fg: Theme.background, bg: Theme.colorDark },
	// branding sentiment - has all colors same so the coral can be accessed as sentiment regardless of foreground, background, ...
	branding: {
		fg: Theme.colorPrimerCoral,
		mg: Theme.colorPrimerCoral,
		bg: Theme.colorPrimerCoral,
	},
}

export default function getSentimentColors(sentiment = 'neutral') {
	return sentimentColors[sentiment]
}
